import { TimelineItem } from 'framework/ui/timeline';
import type { Data } from 'framework/types';
import { KPI_STRUCTURE_READ } from './useKPIService';
import CreateKPIStructure from './Create';
import UpdateKPIStructure from './Update';

export const serviceKPIStructureRegistryConfig = {
  AddForm: CreateKPIStructure,
  UpdateForm: UpdateKPIStructure,
  isApplicable: (item: TimelineItem) => item,
  source: '',
  urlPostfix: 'structures',
  name: 'New KPI structure',
  buttonSize: 'small',
  hasFullData: true,
  permissionToCheck: KPI_STRUCTURE_READ,
  additionalAfterAddSubmit: (item: TimelineItem, parentContext?: Data, reloadData?: () => void) => {
    if (reloadData) {
      reloadData();
    } // reload page for fetch actual state
  },
};
